import {customAxiosBE} from "../config";

export async function getCooperatorsByLineIdAPI(lineId) {
    return customAxiosBE.get(`/cooperators/line/${lineId}`)
}
